import { render, staticRenderFns } from "./inboundDialog.vue?vue&type=template&id=a1a91a28&scoped=true"
import script from "./inboundDialog.vue?vue&type=script&lang=js"
export * from "./inboundDialog.vue?vue&type=script&lang=js"
import style0 from "./inboundDialog.vue?vue&type=style&index=0&id=a1a91a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a91a28",
  null
  
)

export default component.exports